
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth";
import { deleteUserAccount } from '@/contexts/auth/utils/accountManagement';
import { useToast } from "@/hooks/use-toast";

const DeleteAccountSection = () => {
  const { user } = useAuth();
  const { toast } = useToast();

  const deleteAccount = async () => {
    if (!user) return;
    
    try {
      await deleteUserAccount(user.id);
      
      toast({
        title: "Account deleted",
        description: "Your account has been successfully deleted.",
      });
      
      window.location.href = "/";
    } catch (error: unknown) {
      console.error("Error deleting account:", error);
      const message = error instanceof Error ? error.message : 'Unknown error';
      toast({
        title: "Error",
        description: `Failed to delete account: ${message}`,
        variant: "destructive",
      });
    }
  };

  return (
    <section className="mt-6 overflow-hidden rounded-md border border-red-200 bg-white shadow-sm">
      <div className="grid gap-4 p-6 md:grid-cols-[1fr_auto] md:items-center md:p-8">
        <div>
          <h2 className="public-card-title">Delete account</h2>
          <p className="mt-2 text-sm leading-6 text-brand-slate">
            Permanently delete your account and related data. This action cannot be undone.
          </p>
        </div>
      <Button
        variant="destructive"
        onClick={async () => {
          if (window.confirm("Are you sure you want to delete your account? This action cannot be undone.")) {
            try {
              await deleteAccount();
            } catch (error) {
              console.error("Error deleting account:", error);
            }
          }
        }}
      >
        Delete Account
      </Button>
      </div>
    </section>
  );
};

export default DeleteAccountSection;
